export default "__VITE_ASSET__CHcajVs7__"